import { render, staticRenderFns } from "./SofDetail.vue?vue&type=template&id=48df7fca&scoped=true&"
import script from "./SofDetail.vue?vue&type=script&lang=js&"
export * from "./SofDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48df7fca",
  null
  
)

export default component.exports